<template>
    <v-text-field
        ref="input"
        v-model="model"
        v-bind="$attrs"
        v-on="listeners"
        :hide-details="shouldHideDetails"
        :error-messages="errorMessages"
        v-mask="currentMask"
        @blur="handleBlur"
        :document-type="documentType"
    ></v-text-field>
</template>

<script>
import mask from '@services/mask'

export default {
    inheritAttrs: false,

    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        errors: {
            type: Object,
            default: null,
        },
        errorName: {
            type: String,
            default: '',
        },
        hint: {
            type: String,
            default: undefined,
        },
        documentType: {
          type: String,
          default: null,
        },
    },

    data: () => ({
        internalValue: '',
    }),

    computed: {
        model: {
            get() {
                return this.internalValue
            },
            set(value) {
                const normalized = this.normalizeValue(value)

                if (normalized !== this.internalValue) {
                    this.internalValue = normalized
                }

                const raw = this.toRaw(normalized)

                this.$emit('input', normalized)
                this.$emit('update:raw', raw)
                this.$emit('document-raw', raw)
            },
        },

        currentMask() {
          if (this.documentType) {
            return this.documentType.toLowerCase() === 'cnpj' ? mask.CNPJ : mask.CPF
          }

          const raw = this.toRaw(this.internalValue)
          const hasLetters = /[A-Z]/.test(raw)

          if (raw.length > 11 || hasLetters) {
            return mask.CNPJ
          }

          return mask.CPF
      },

        listeners() {
            const { input, blur, ...listeners } = this.$listeners
            return listeners
        },

        errorMessages() {
            if (this.errors && typeof this.errors.list === 'function' && this.errorName) {
                return this.errors.list(this.errorName)
            }

            const attrErrors = this.$attrs['error-messages']
            return Array.isArray(attrErrors) ? attrErrors : attrErrors ? [attrErrors] : []
        },

        shouldHideDetails() {
            return !(this.errorMessages && this.errorMessages.length) && !this.hint
        },
    },

    watch: {
        value: {
            immediate: true,
            handler(newValue) {
                const normalized = this.normalizeValue(newValue)

                if (normalized !== this.internalValue) {
                    this.internalValue = normalized
                }
            },
        },
    },

    methods: {
        focus() {
            this.$refs.input && this.$refs.input.focus()
        },

        normalizeValue(value) {
            if (value === null || value === undefined) {
                return ''
            }

            return String(value)
                .toUpperCase()
                .replace(/[^A-Z0-9./-]/g, '')
        },

        toRaw(value) {
            return (value || '').replace(/[^A-Z0-9]/g, '')
        },

        handleBlur(event) {
            if (this.errors && typeof this.errors.remove === 'function' && this.errorName) {
                this.errors.remove(this.errorName)
            }

            if (this.$listeners.blur) {
                this.$emit('blur', event)
            }
        },
    },
}
</script>
